import { STORAGE_KEY } from "./config";

// getUserHash returns a 32-hex-char first-party identifier persisted in
// localStorage. The value is opaque (no PII) and used by /serve for
// frequency capping and audience membership. Generation uses
// crypto.getRandomValues — 16 random bytes ≈ 128 bits of entropy.
//
// Fallback chain handles Safari's "Prevent Cross-Site Tracking" and any
// other situation where localStorage throws (storage disabled, quota
// exceeded). In that case the value lives only for the page session, which
// is fine: frequency capping degrades gracefully.

let cached: string | null = null;

export function getUserHash(): string {
  if (cached) return cached;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored && /^[a-f0-9]{32}$/.test(stored)) {
      cached = stored;
      return stored;
    }
    const fresh = newID();
    window.localStorage.setItem(STORAGE_KEY, fresh);
    cached = fresh;
    return fresh;
  } catch {
    if (!cached) cached = newID();
    return cached;
  }
}

function newID(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let out = "";
  for (let i = 0; i < bytes.length; i++) {
    const b = bytes[i] ?? 0;
    out += b.toString(16).padStart(2, "0");
  }
  return out;
}
